module.exports = __webpack_public_path__ + "static/media/img.back.75888f19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/AppStore/AppManage/AppBatchSetPower/UI.Head/img.back.svg
// module id = 6379
// module chunks = 0